<template>
  <div class="wrapper d-flex justify-content-center align-items-center">
    <div class="flex-row w-100">
      <el-card class="flex-column mt-5 text-center">
        procesando respuesta ...
      </el-card>
    </div>
  </div>
</template>
<script>
import auth from '@/service/auth'
import {Card} from "element-ui";

export default {
  components: {
    [Card.name]: Card,
  },
  mounted() {

    const currUrl = window.location.href
    auth.auth.parseCognitoWebResponse(currUrl)

  },
  data() {
    return {}
  }
}
</script>
